import React, { useState } from 'react';
import './FAQ.css';

const faqs = [
  { q: 'What services does SocialManiacs offer?', a: 'Social Media Management , Content Creation , Graphic Designing , Video Production , Influencer Marketing , Brand Strategy , Advertising campaigns , Web design & development , SEO/SEM , Social Media , Performance Marketing and analytics & Conversion Optimization.' },
  { q: 'What makes SocialManiacs different from other digital agencies?', a: 'We combine full-funnel strategy with execution, fast iteration, and measurable KPIs—delivering results, not just deliverables.' },
  { q: 'Do you only handle online marketing?', a: 'We’re a 360° agency offering both digital and offline marketing — from print and events to branding materials — ensuring your presence stays consistent across all channels.' },
  { q: 'Do you work with small businesses or only established brands?', a: 'Both. We tailor scope and channels to your stage—startups, SMBs, and enterprise teams all work with us.' },
  { q: 'Can I choose only specific services instead of a full package?', a: 'Yes. You can start with a single service (Social media, SEO or Paid Campaigns) and expand as we scale results together.' }
];

export default function FAQ(){
  const [open, setOpen] = useState(null);
  return (
    <section className="faq-section py-5">
      <div className="container">
        <div className="row g-4 align-items-center">
          <div className="col-lg-5 order-lg-1 order-2">
            <div className="faq-cards">
              <img src="images/collaborative.png" alt="FAQ Card 1" className="faq-card faq-card-1 scroll-reveal" />
              <img src="images/tcb.jpg" alt="FAQ Card 2" className="faq-card faq-card-2 scroll-reveal" />
            </div>
          </div>
          <div className="col-lg-7 order-lg-2 order-1">
            <h2 className="fw-bold mb-4 text-center text-lg-start">How to Get <span className="gradient-text">Quality</span> Work With <span className="gradient-text">Us</span></h2>
            <div className="faq-list">
              {faqs.map((item, idx)=>{
                const isOpen = open === idx;
                return (
                  <div key={idx} className={`faq-item ${isOpen? 'open':''}`}>
                    <button className="faq-toggle" onClick={()=> setOpen(isOpen? null: idx)} aria-expanded={isOpen}>
                      <span>{item.q}</span>
                      <span className="faq-icon">{isOpen? '−':'+'}</span>
                    </button>
                    {isOpen && (
                      <div className="faq-answer">
                        <p className="mb-0 text-muted">{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
